export function accordion() {
    const accordionBlock = $(".accordion");
    accordionBlock.on("click", ".heading", function (e) {
        let accordion = $(this).parents(".accordion");
        let parent = $(this).parent();
        if (parent.hasClass("opened")) {
            parent.removeClass("opened").find(".hidden-info").slideUp();
        } else {
            accordion.find(".accordion-item").removeClass("opened").find(".hidden-info").slideUp();
            parent.addClass("opened").find(".hidden-info").slideDown();
        }
        e.preventDefault();
    });

    accordionBlock.each(function () {
        const $this = $(this);
        if (!$this.parent().hasClass("sticky-menu")) {
            setTimeout(() => {
                if (!$this.find(".accordion-item:first-child").hasClass("opened")) {
                    $this.find(".accordion-item:first-child .heading").trigger('click');
                }
            }, 100);
        }
    });

    $('.sticky-menu-title').on('click', function () {
        if (window.innerWidth < 768) {
            $(this).toggleClass('opened');
            $(this).next().slideToggle();
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js